import { useState } from 'react';
import { MarktechModal } from '../../../../Atoms/Modal';
import { TPricingPlans } from '../../../../S/pricing/types';
import { startFilingLinkViewPlans } from '../../../static/data';
import { ButtonWithAnchor } from '../../hero-section/sticky-button';
import { ViewNewPlanModalContent } from '../../hero-section/view-new-plan-modal-content';
import { ApiPlan } from '../../hero-section/view-new-plan-modal-content/types';
import { ButtonVariants } from '../../../../Atoms/Button';

interface START_FREE_BANNER_PROPS {
  heading: string;
  desc: string;
  planData?: {
    text: string;
    originalPrice: string;
    discountedPrice: string;
  };
  button1: {
    text: string;
    url: string;
  };
  button2?: {
    text: string;
    url: string;
  };
  priceMapData: Record<string, TPricingPlans>;
  plans: ApiPlan[];
}

export const StartForFreeBanner = ({
  heading,
  desc,
  planData,
  button1,
  button2,
  plans,
}: START_FREE_BANNER_PROPS): JSX.Element => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePlanModal = () => setIsPopupVisible(!isPopupVisible);

  return (
    <div
      className="rounded-xl"
      style={{
        background:
          'linear-gradient(83.55deg, #FFFFFF -10.46%, #EEF5FF 110.91%)',
        border: '1px solid #B7D5FE',
      }}
    >
      <div className="startFreeBanner bg-right-bottom bg-no-repeat p-9 sm:bg-none sm:px-4 sm:py-6">
        <h2 className="text-s-48 mb-2 md:text-s-40 sm:text-s-24">{heading}</h2>
        <p className="text-font-500 text-s-20 sm:text-base">{desc}</p>

        <div className="mt-12 mb-6 sm:mt-8 sm:mb-4 ">
          {planData ? (
            <>
              <span className="text-s-20 sm:text-base font-medium">
                {planData.text}
              </span>
              <span className="text-[#1572ED] text-s-32 font-bold pr-2 sm:text-s-30">
                {planData.discountedPrice}
              </span>
              <span className="text-font-200 orange-strike-through text-s-20">
                {planData.originalPrice}
              </span>
            </>
          ) : null}
        </div>

        <div className="flex items-start justify-start gap-6 sm:flex-col w-1/2 sm:w-full">
          <ButtonWithAnchor
            className="sm:w-full w-44"
            buttonText={button1.text}
            trackLabel={`inpage_income_tax_efiling`}
            buttonLink={button1.url}
            buttonVariant={ButtonVariants.bluefilled}
          />

          {button2 ? (
            <>
              <ButtonWithAnchor
                buttonText="View Plans"
                isStickyOnMobile={false}
                onClickHandler={() => togglePlanModal()}
                trackLabel={`inpage_income_tax_efiling`}
                className="w-44 sm:w-full"
                buttonVariant={ButtonVariants.bluebordered}
              />

              <MarktechModal
                open={isPopupVisible}
                onClose={togglePlanModal}
                closeIcon={'✕'}
                classNames={{
                  modal:
                    'mobile-search-box rounded-2xl md:w-11/12 sm:w-11/12 h-fit max-h-[90vh] overflow-hidden maxWidth',
                  closeIcon: 'absolute',
                }}
                center
              >
                <div
                  className="modal rounded-xl modal-open bg-[#EEF5FF]  w-full"
                  id="contact-sales"
                  data-fold-location="navbar_button_Book a demo"
                >
                  <ViewNewPlanModalContent
                    trackLabel="test-label"
                    plansList={plans}
                    buttonLink={startFilingLinkViewPlans}
                  />
                </div>
              </MarktechModal>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
